// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1F3hK","content":"GlobalSearch_content__1kQ9_"};